<div class="dialogWrapper" [ngClass]="data.type">
    <header>
        <h2>{{ data.title | translate }}</h2>
    </header>
    @if (isArrayOfBodyElements) {
        <div class="multiLine">
            @for (bodyElement of data.body; track bodyElement) {
                <div [innerHTML]="bodyElement | translate | safeHtml"></div>
            }
        </div>
    } @else {
        <div [innerHTML]="data.body.toString() | translate | safeHtml"></div>
    }
    <footer>
        <button class="button" [ngClass]="{ primary: data.defaultYesButton }" (click)="close(true)">
            {{ data.yesButtonText | translate }}
        </button>
        <button class="button" [ngClass]="{ primary: !data.defaultYesButton }" (click)="close(false)">
            {{ data.noButtonText | translate }}
        </button>
    </footer>
</div>
